export default __webpack_public_path__ + "static/media/robert.24a5b43b.jpg";